import { defineStore } from 'pinia';
import { DashboardService } from '@/services/DashboardService';
import { Promotion } from '@/utils/types/promotion';

export const usePromotionStore = defineStore('promotionPopup', {
  state: () => ({
    promotionData: [] as Promotion[],
    activePromotionData: [] as Promotion[],
    showPromotionDialog: false,
  }),
  actions: {
    setPromotionData(data: Promotion[]) {
      if (data.length === 0) {
        this.promotionData = [];
        this.showPromotionDialog = false;
        return;
      }

      this.promotionData = data.slice().filter((item) => !item.blockModal);
      this.activePromotionData = data.slice();
      // this.activePromotionData = data.slice().sort((a, b) => {
      //   // First, prioritize items where isPromotion is true
      //   const aIsPromotion = a.promotionSettings?.isPromotion ?? false;
      //   const bIsPromotion = b.promotionSettings?.isPromotion ?? false;
      //   if (aIsPromotion !== bIsPromotion) {
      //     return aIsPromotion ? -1 : 1;
      //   }
      //   // Then sort by date (newest first)
      //   const dateA = new Date(a.createdDatetime).getTime();
      //   const dateB = new Date(b.createdDatetime).getTime();
      //   return dateB - dateA;
      // });
      if (this.promotionData.length > 0) {
        this.showPromotionDialog = true;
      }
    },
    clearPromotionData() {
      this.promotionData = [];
      this.activePromotionData = [];
    },
    async blockPromotion(id: string) {
      const response = await DashboardService.blockPromotion(id);
      return response;
    },
    closePromotionDialog() {
      this.showPromotionDialog = false;
    },
  },
});